import { E } from '@angular/cdk/keycodes';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoogleCalendarServiceAccountService {



  url = environment.serverAPI9 + "/api/googleCalendar";

  url1 = environment.serverAPI9 + "/api";

  url2 = environment.serverAPI9 + "/api/googleCalenderNew";

  constructor(private http: HttpClient) { }


  searchGoogleCalendar(query: string, page: number, size: number, sort: string, additionalQuery: string): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,

      additionalQuery: additionalQuery != null ? additionalQuery : null,

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url2}/condition${queryParams}`, requestBody);
  }

  getAllGoogleCalendar(Page: any, size: any, sort: any, typeId: any, type: any, leadId: any, meetingType: any): Observable<Object> {

    if (type == 1) {
      return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
    } else {

      return this.http.get(`${this.url}/lead/${leadId}/${meetingType}?page=${Page}&size=${size}&sort=${sort}`);
    }

  }

    getAllGoogleCalendarNew(Page: any, size: any, sort: any, typeId: any, type: any, leadId: any, meetingType: any): Observable<Object> {

      return this.http.get(`${this.url}/lead/${leadId}/${meetingType}?page=${Page}&size=${size}&sort=${sort}`);

  }

  getAllDynmaicFormDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  // productNotLinkedSearch(linkedProduts,Page: number, size: number, sort: any): Observable<Response[]> {
  // 	return this.http.post<Response[]>(`${this.url}/linked/search?page=${Page}&size=${size}&sort=${sort}`, linkedProduts);
  // }

  getGoogleCalendarById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  // addOrEditGoogleCalendar(googleCalendar: any): Observable<Response[]> {

  //   if(googleCalendar.id>0){
  //     return this.http.put<Response[]>(`${this.url}/update-meeting/${googleCalendar.id}`, googleCalendar);
  //   }else{
  //     return this.http.post<Response[]>(`${this.url}/create-meeting`, googleCalendar);
  //   }

  // }

  addOrEditGoogleCalendar(googleCalendar: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, googleCalendar);
  }

  googleCalendarSearch(query, Page: any, size: any, sort: any, type: any, leadId: any): Observable<Object> {
    if (type == 1) {
      return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
    } else {
      query = query + " AND entityId:" + leadId;
      return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
    }
  }

  customerNotLinked(linkedDynamic, Page: number, size: number, sort: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/linked?page=${Page}&size=${size}&sort=${sort}`, linkedDynamic);
  }

  customerNotLinkedSearch(linkedProduts, Page: number, size: number, sort: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/linked/search?page=${Page}&size=${size}&sort=${sort}`, linkedProduts);
  }

  deleteCalenderById(id: any): Observable<Object> {
    return this.http.delete(`${this.url1}/delete-meeting/${id}`);
  }

  generateMeetLink(id) {
    return this.http.get(`${this.url1}/generate/meetlink/${id}`);
  }

  uploadGoogleCalendar(googleCalendar: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/bulk/import`, googleCalendar);
  }

}
